import React, { useState } from 'react';
import { Column } from 'primereact/column';
import { DataTable } from 'primereact/datatable';
import { HighOverviewReportTypeRes } from '../../../../api/types/reports/high-overview/high-overview.type';

interface HighLevelOverviewExamsProps {
  data: HighOverviewReportTypeRes | undefined;
}

export const HighLevelOverviewExams: React.FC<HighLevelOverviewExamsProps> = ({
  data,
}) => {
  // Format date for display
  const formatDate = (date: Date | undefined) => {
    if (!date) return '-';
    return new Date(date).toLocaleDateString('he-IL');
  };

  // Calculate exam duration in hours
  const calculateExamHours = (startTime: Date, endTime: Date) => {
    const diffMs = new Date(endTime).getTime() - new Date(startTime).getTime();
    const diffHours = diffMs / (1000 * 60 * 60);
    return Math.round(diffHours * 10) / 10; // Round to 1 decimal place
  };

  return (
    <div>
      <DataTable
        emptyMessage={<div style={{ textAlign: 'right' }}>לא נמצאו נתונים</div>}
        value={data?.exams || []}
        scrollable
        scrollHeight="180px"
      >
        <Column
          style={{ textAlign: 'right' }}
          field="branchName"
          header="שלוחה"
          sortable
        />
        <Column
          style={{ textAlign: 'right' }}
          field="abstractProgramName"
          header="תוכנית"
          sortable
        />
        <Column
          style={{ textAlign: 'right' }}
          field="courseName"
          header="קורס"
          sortable
        />
        <Column
          style={{ textAlign: 'right' }}
          header="תאריך"
          sortable
          body={(rowData) => formatDate(rowData.sessionDate)}
        />
        {/*<Column
          style={{ textAlign: 'right' }}
          header="שעות"
          sortable
          body={(rowData) =>
            calculateExamHours(rowData.sessionStartTime, rowData.sessionEndTime)
          }
        />*/}
      </DataTable>
    </div>
  );
};
